export default __webpack_public_path__ + "static/media/mice_03.be32d733.png";